import { GameScore, GameTeam, SMPDivider, SMPFlex, SMPLinkWrapper } from '../../../../index';
import { IPlayoffResult, IPlayoffRoundGroup } from '../../../../../types/playoff';
import { resultTypeForDisplaying } from '../../../../../constants/playoff';
import { TEAM_ENTITY } from '../../../../../constants/entityTypes';
import { assetsPlaceholder } from '../../../../../constants/assetsPlaceholder';
import { Sports } from '../../../../../constants/sportType';
import { IBaseTeam } from '../../../../../types';

export interface IKnockoutGameDoublesProps {
  group: IPlayoffRoundGroup;
  handleEventClick?: (id: string | number) => void;
  sport?: string;
  isNational?: boolean;
}

export const KnockoutGameDoubles = ({ group, handleEventClick, sport, isNational }: IKnockoutGameDoublesProps): JSX.Element => {
  const groupResult = group?.results?.find((result: IPlayoffResult) => result?.resultType?.type === resultTypeForDisplaying) || null;
  const firstDouble = (group && group.participants && group.participants[0]) || null;
  const secondDouble = (group && group.participants && group.participants[1]) || null;

  return (
    <div style={{ marginBottom: '8px', display: 'grid' }}>
      <SMPLinkWrapper href={group.matchLink} target={group.urlTarget} onClick={() => handleEventClick && handleEventClick(group.id)}>
        <SMPFlex
          variant='livescoreMatch'
          css={{
            border: '2px solid #707070',
            borderRadius: '$3',
            width: '100%',
            py: '$1',
            px: '$3',
            backgroundColor: '$rowBackgroundColor',
            minWidth: 'max-content',
          }}
          justify='spaceBetween'
        >
          <SMPFlex variant='column' align='start' css={{ width: '100%' }}>
            <SMPFlex justify='spaceBetween' css={{ width: '100%' }}>
              <SMPFlex variant='column' align='start'>
                {firstDouble?.details?.map((team, index) => {
                  const winner = firstDouble?.winner?.value === 'YES';
                  const logo =
                    firstDouble?.entityType === TEAM_ENTITY ? assetsPlaceholder[TEAM_ENTITY] : assetsPlaceholder.tennisParticipant;
                  const teamName = team?.name;

                  return (
                    <GameTeam
                      isWinner={winner}
                      key={`${team?.id}${index}`}
                      imageVariant={
                        sport === Sports.TENNIS && !team?.country?.assets?.flag?.url
                          ? 'tennisParticipantPlayoffLogo'
                          : 'mediumLivescoreEntityLogo'
                      }
                      teamName={teamName}
                      teamLogo={team?.country?.assets?.flag?.url ?? logo}
                      team={team as IBaseTeam}
                      isNational={isNational}
                    />
                  );
                })}
              </SMPFlex>
              {groupResult && groupResult.participants && groupResult.participants.length > 0 && (
                <SMPFlex css={{ paddingLeft: '$3' }}>
                  <GameScore
                    eventId={group.id}
                    verticalAlign
                    homeTeamScore={groupResult.participants.find((participant) => participant.id === firstDouble?.id)?.value}
                  />
                </SMPFlex>
              )}
            </SMPFlex>
            <SMPDivider />
            <SMPFlex justify='spaceBetween' css={{ width: '100%' }}>
              <SMPFlex variant='column' align='start'>
                {secondDouble?.details?.map((team, index) => {
                  const winner = secondDouble?.winner?.value === 'YES';
                  const logo =
                    secondDouble?.entityType === TEAM_ENTITY ? assetsPlaceholder[TEAM_ENTITY] : assetsPlaceholder.tennisParticipant;

                  return (
                    <GameTeam
                      isWinner={winner}
                      key={`${team?.id}${index}`}
                      imageVariant={
                        sport === Sports.TENNIS && !team?.country?.assets?.flag?.url
                          ? 'tennisParticipantPlayoffLogo'
                          : 'mediumLivescoreEntityLogo'
                      }
                      teamName={team?.name}
                      teamLogo={team?.country?.assets?.flag?.url ?? logo}
                      team={team as IBaseTeam}
                      isNational={isNational}
                    />
                  );
                })}
              </SMPFlex>
              {groupResult && groupResult.participants && groupResult.participants.length > 0 && (
                <SMPFlex css={{ paddingLeft: '$3' }}>
                  <GameScore
                    eventId={group.id}
                    verticalAlign
                    awayTeamScore={groupResult.participants.find((participant) => participant.id === secondDouble?.id)?.value}
                  />
                </SMPFlex>
              )}
            </SMPFlex>
          </SMPFlex>
        </SMPFlex>
      </SMPLinkWrapper>
    </div>
  );
};
